import React from 'react';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { status as statusObject } from '../../../../helpers/StrategyProject/stratProjectHelpers';
import tableApproved from '../../../../../img/icons/tableApproved.svg';
import tableDeclined from '../../../../../img/icons/tableDeclined.svg';
import tableProjOffice from '../../../../../img/icons/tableProjOffice.svg';
import tableInProjOffice from '../../../../../img/icons/tableInProjOffice.svg';
import tableAchieved from '../../../../../img/icons/tableAchieved.svg';

const mapStatuses = new Map()
  .set(statusObject.onProjOffice, tableInProjOffice)
  .set(statusObject.returned, tableProjOffice)
  .set(statusObject.inProgress, tableProjOffice)
  .set(statusObject.approved, tableApproved)
  .set(statusObject.declined, tableDeclined)
  .set(statusObject.isCreating, '')
  .set(statusObject.achieved, tableAchieved);
function ImageStatus({ status, comment, onClick }) {
  const sizeIcon = 16;
  const gap = 8;
  return (

    <div style={{
      display: 'flex', flexDirection: 'row', gap: comment ? `${gap}px` : `${sizeIcon + gap}px`, marginRight: comment ? '35px' : `${35 + sizeIcon}px`, width: '100%', boxSizing: 'border-box', marginTop:'14px'
    }}
    >
      <img src={mapStatuses.get(status)} width={25} alt={status} />
      {(status === statusObject.returned || status === statusObject.declined)
        ? (
          <HelpOutlineIcon
            onClick={onClick}
            style={{
              opacity: '0.66', fontSize: `${sizeIcon}px`, alignSelf: 'center', cursor: 'pointer',
            }}
            fontSize="inherit"
          />
        )
        : <span />}
    </div>
  );
}

export default ImageStatus;
